import _ from "lodash";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Button, ButtonGroup, Card, CardBody, Col, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { ItemTypeahead, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, dateHelpers, helpers } from '../utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function PMItemPriceHistory(props) {
   const navigate = useNavigate();
   const { itemNumber } = useParams();
   const [item, setItem] = useState(null);
   const [itemWithDesc, setItemDesc] = useState(null);
   const [loaded, setLoaded] = useState(true);
   const [vendor, setVendor] = useState(null);
   const [vendorItem, setVendItem] = useState(null);
   const [vm, setModel] = useState([]);
   const refresh = () => window.location.reload(true)

   useEffect(() => {
      if (itemNumber) {
         const opt = decodeURI(itemNumber);
         onItemLoad(opt);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      if (item) {
         setLoaded(false);
         api
            .fetch(`Purchasing/PurchaseItemPricingHistory/${item}`)
            .then(response => {
               //console.log(response.data);
               if (response.data.success) {
                  setModel(response.data.model);
                  var idx = response.data.model.length - 1;
                  if (idx >= 0) {
                     setItemDesc(response.data.model[idx].itemWithDesc);
                     setVendor(response.data.model[idx].vendorWithName);
                     setVendItem(response.data.model[idx].vendorItemWithDesc);
                  }
               }
               else {
                  setModel([]);
                  setItemDesc(null);
                  setVendor(null);
                  setVendItem(null);
                  toast.error(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setModel([]);
               setItemDesc(null);
               setVendor(null);
               setVendItem(null);
            })
            .finally(() => {
               setLoaded(true);
            });
      }
      else {
         setModel([]);
         setItemDesc(null);
         setVendor(null);
         setVendItem(null);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [item])

   function exportXlsx() {
      let url = `Purchasing/ExportPriceHistory/${item}`;
      api
         .postGetBlob(url, null)
         .then((response) => {
            if (response.data.success === false) {
               if (_.isString(response?.data?.message)) {
                  toast.error(response?.data?.message);
               }
               return;
            }
            if (response.data) {
               const XLSX_FILENAME = `${item}_Price_History.xlsx`;
               helpers.downloadExport(
                  response.data,
                  XLSX_FILENAME,
                  constants.MIME_TYPES.xlsx
               );
            } else {
               toast.error(response.message || "Error downloading report");
            }
         })
         .catch(
            api.catchHandler
         );
   }

   function onItemChange(opt) {
      if (_.isNil(opt)) {
         setItem(null);
         setModel([]);
         setItemDesc(null);
         setVendor(null);
         setVendItem(null);
      } else {
         var nav = constants.ENDPOINTS.purchasePriceHistory + "/" + opt.itemNumber;
         navigate(nav);
         refresh();
      }
   }

   function onItemLoad(itm) {
      if (_.isNil(itm)) {
         setItem(null);
      } else {
         setItem(itm);
      }
   }

   return (
      <>
         <DesktopContainer screenName="Item Price History">
            <Card className="dashboard-card">
               <CardBody>
                  <div className="filter-header mb-2">
                     <div className="text-center text-white mb-2">
                        <span className="h4">Item Price History</span>
                     </div>
                     <Row>
                        <Col xs={3} className="h5 text-white text-end align-self-center">
                           Item:
                        </Col>
                        <Col xs={6}>
                           <ItemTypeahead
                              name="itemInput"
                              value={item}
                              onChange={(opt) => onItemChange(opt)}
                           />
                        </Col>
                     </Row>
                  </div>

                  <br />
                  {vm && vm.length > 0 ?
                     <div>
                        <Row>
                           <Col className="h5 align-self-center">Item: {itemWithDesc}</Col>
                        </Row>
                        <Row>
                           <Col className="h5 align-self-center">Current Vendor: {vendor}</Col>
                        </Row>
                        <Row>
                           <Col className="h5 align-self-center">Vendor Item: {vendorItem}</Col>
                           <Col className="transparent-background">
                              <ButtonGroup className="float-end">
                                 <Button
                                    title="Download as .xlsx"
                                    className="shredButtonExcel float-end me-3"
                                    onClick={exportXlsx}
                                    disabled={!loaded}
                                 >
                                    <FontAwesomeIcon icon="file-excel" size="lg" />
                                 </Button>
                              </ButtonGroup>
                           </Col>
                        </Row>
                     </div>
                     : null
                  }
                  <Table striped size="sm" className="data-table w-85 mx-auto">
                     <thead className="table-header">
                        <tr>
                           <th width="15%" style={{ textAlign: "center" }}>Date</th>
                           <th width="15%" style={{ textAlign: "center" }}>Price</th>
                           <th width="15%" style={{ textAlign: "center" }}>Ref</th>
                           <th width="15%" style={{ textAlign: "center" }}>Qty</th>
                           <th width="15%" style={{ textAlign: "center" }}>Cost</th>
                           <th width="25%" />
                        </tr>
                     </thead>
                     <tbody>
                        {!loaded ? (
                           <tr>
                              <td colSpan={7}>
                                 <ServiceThreadSpinner on={true} />
                              </td>
                           </tr>
                        ) : vm.length === 0 ? (
                           <tr>
                              <td colSpan={7} className="h5 fw-bold text-center">
                                 No Data Found
                              </td>
                           </tr>
                        ) : (
                           _.map(vm, (datum, i) => {
                              return (
                                 <tr>
                                    <td className="data-cell" style={{ textAlign: "center" }}>{dateHelpers.toLongDateString(datum.poDate)}</td>
                                    <td className="data-cell" style={{ textAlign: "center" }}>{helpers.formatCurrency(datum.unitCost)}</td>
                                    <td className="data-cell" style={{ textAlign: "center" }}>{datum.poNum}</td>
                                    <td className="data-cell" style={{ textAlign: "center" }}>{helpers.formatNumberWithThousands(datum.qty)}</td>
                                    <td className="data-cell" style={{ textAlign: "center" }}>{helpers.formatCurrency(datum.extCost)}</td>
                                    <td className="data-cell">&nbsp;</td>
                                 </tr>
                              );
                           })
                        )}
                     </tbody>
                     <tfoot className="table-footer">
                        <tr>
                           <td colSpan={2} />
                           <td className="fw-bold" style={{ textAlign: "right" }}>Totals:<br />Avg Cost /Lb:</td>
                           <td className="fw-bold" style={{ textAlign: "center" }}>
                              {helpers.formatNumberWithThousands(_.sumBy(vm, datum => datum.qty))}<br />
                              {helpers.formatCurrency(_.sumBy(vm, datum => datum.extCost) / _.sumBy(vm, datum => datum.qty))}
                           </td>
                           <td className="fw-bold" style={{ textAlign: "center" }}>{helpers.formatCurrency(_.sumBy(vm, datum => datum.extCost))}<br />&nbsp;</td>
                           <td />
                        </tr>
                     </tfoot>
                  </Table>
               </CardBody>
            </Card>
         </DesktopContainer >
      </>
   );
}
